export default __webpack_public_path__ + "static/media/skone.11a46173.png";